<template lang="pug">
  svg
    line(x1="0", y1="50%", x2="100%", y2="50%", :stroke-width="strokeWidth", stroke="currentColor")
    line(x1="50%", y1="0%", x2="50%", y2="100%", :stroke-width="strokeWidth", stroke="currentColor", v-show="!minus")
</template>

<script>
export default {
  name: 'SVG-PlusMinus',
  props: {
    minus: Boolean,
    strokeWidth: { type: String, default: '1.5px' }
  }
}
</script>

<style>
</style>
